import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		id: 'servicedesk-insight-projects-picker.error-flag-title',
		defaultMessage: 'We couldn’t load your projects',
		description: 'Error title when failing to load list of projects',
	},
	errorFlagDescription: {
		id: 'servicedesk-insight-projects-picker.error-flag-description',
		defaultMessage: 'Please check your network and try again',
		description: 'Error message when failing to load list of projects',
	},
});
